import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module, Right} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {CheckService} from '../../services/check.service';

@Component({
  selector: 'app-wheelnews',
  templateUrl: './wheelnews.component.html',
  styleUrls: ['./wheelnews.component.css']
})

export class WheelnewsComponent implements OnInit {

  public translation: Translation;
  public wheelnewsTaskModule: Module;
  public wheelnewsOrderviewModule: Module;
  public rights: Right[];

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkModule(20);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.rights = JSON.parse(sessionStorage.getItem('Rights'));
    this.rights.forEach(right => {
      switch (right.RightId) {
        case 6:
          this.wheelnewsTaskModule = new Module();
          this.wheelnewsTaskModule.ModuleName = this.translation.WheelNewsTaskCardTitle;
          this.wheelnewsTaskModule.ModuleDesc = this.translation.WheelNewsTaskCardDesc;
          this.wheelnewsTaskModule.ModuleButtonText = this.translation.WheelnewsTaskCardAction;
          this.wheelnewsTaskModule.ForwardLink = '/wheelnews-task';
          break;
        case 7:
          this.wheelnewsOrderviewModule = new Module();
          this.wheelnewsOrderviewModule.ModuleName = this.translation.WheelnewsOrderviewCardTitle;
          this.wheelnewsOrderviewModule.ModuleDesc = this.translation.WheelnewsOrderviewCardDesc;
          this.wheelnewsOrderviewModule.ModuleButtonText = this.translation.WheelnewsOrderviewCardAction;
          this.wheelnewsOrderviewModule.ForwardLink = '/wheelnews-orderview';
          break;
      }
    });
  }

  navigate(forwardLink: string) {
    this.router.navigate([forwardLink]);
  }
}
